import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Solutions from './pages/Solutions';
import About from './pages/About';
import Pricing from './pages/Pricing';
import Contact from './pages/Contact';
import Work from './pages/Work';
import Blog from './pages/Blog';
import Documentation from './pages/Documentation';
import Support from './pages/Support';
import FAQ from './pages/FAQ';
import Careers from './pages/Careers';
import ClientOnboarding from './pages/ClientOnboarding';
import ClientDashboard from './pages/client/Dashboard';
import EMHDashboard from './pages/emh/Dashboard';
import CyBieLayout from './pages/cybie/CyBieLayout';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CookiePolicy from './pages/CookiePolicy';
import GDPR from './pages/GDPR';
import { useAuthStore } from './store/authStore';

function App() {
  const { initializeAuth } = useAuthStore();

  useEffect(() => {
    console.log('[App] Calling initializeAuth...');

    // Add timeout to prevent blocking
    const authTimeout = setTimeout(() => {
      console.warn('[App] initializeAuth timed out after 5s');
    }, 5000);

    initializeAuth()
      .then(() => {
        clearTimeout(authTimeout);
        console.log('[App] initializeAuth completed');
      })
      .catch((error) => {
        clearTimeout(authTimeout);
        console.error('[App] initializeAuth failed:', error);
      });
  }, [initializeAuth]);

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* CyBie Portal - Standalone without Navbar/Footer */}
        <Route path="/cybie/*" element={
          <ProtectedRoute requiredRole="cybie">
            <CyBieLayout />
          </ProtectedRoute>
        } />

        {/* EMH Portal - Standalone without Navbar/Footer - Protected */}
        <Route path="/emh/*" element={
          <ProtectedRoute requiredRole="emh">
            <EMHDashboard />
          </ProtectedRoute>
        } />

        {/* Main Application with Navbar/Footer */}
        <Route path="*" element={
          <div className="min-h-screen flex flex-col bg-gray-50">
            <Navbar />
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/onboarding" element={<ClientOnboarding />} />
                <Route path="/solutions" element={<Solutions />} />
                <Route path="/work" element={<Work />} />
                <Route path="/about" element={<About />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/documentation" element={<Documentation />} />
                <Route path="/support" element={<Support />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/careers" element={<Careers />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsOfService />} />
                <Route path="/cookies" element={<CookiePolicy />} />
                <Route path="/gdpr" element={<GDPR />} />
                <Route path="/client/*" element={<ClientDashboard />} />
              </Routes>
            </main>
            <Footer />
          </div>
        } />
      </Routes>
    </Router>
  );
}

export default App;